import { CsvPayload } from '../../common/models/CsvPayload';

export class ReportCsvData {
  constructor(
    private readonly inventory: CsvPayload,
    private readonly issues: CsvPayload,
    private readonly instances: CsvPayload,
    private readonly objectStats: CsvPayload
  ) {}

  getInventory() {
    return this.inventory;
  }

  getIssues() {
    return this.issues;
  }

  getInstances() {
    return this.instances;
  }

  getObjectStats() {
    return this.objectStats;
  }
}
